interface UserInfo {
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  additionalInfo?: string;
}

interface EmailTemplate {
  subject: string;
  body: string;
}

export const generateSupportEmail = (storeName: string, user: UserInfo): EmailTemplate => ({
  subject: `Store ${storeName} not found on Contextual`,
  body: `Hi,

I received an error while trying to access Contextual.

My details:
- Name: ${user.firstName ?? ''} ${user.lastName ?? ''}
- Email: ${user.email ?? ''}
${user.additionalInfo ? `\n${user.additionalInfo}` : ''}

Could you please help me investigate this issue?

Thanks!`
});

export const generateAccessRequestEmail = (storeName: string, user: UserInfo): EmailTemplate => ({
  subject: `Request access to ${storeName} store`,
  body: `Hi,

I would like to request access to the ${storeName} store on Contextual.
My details:
- Name: ${user.firstName ?? ''} ${user.lastName ?? ''}
- Email: ${user.email ?? ''}

Thanks!`
});

export const generateEmailLink = (template: EmailTemplate): string => {
  return `mailto:support@getcontextual.io?subject=${encodeURIComponent(template.subject)}&body=${encodeURIComponent(template.body)}`;
};
